// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"e56745f7","257":"1d517181"}[chunkId] + ".chunk.js";
};